import { Request } from './../Shared/Request';

export class Stats {
    constructor(config) {
        this.request = new Request();
        this.url = config.url;
        this.params = {};
    }

    getStats(typeId) {
        this.params = {
            "CurrAgentsLoggedIn": {
                "objectId":typeId,
                "objectType":"groupAgents",
                "tenant":"Resources","metric":"CurrAgentsLoggedIn",
                "notificationMode":"NoNotification"
            },
            "CurrentReadyAgents": {
                "objectId":typeId,
                "objectType":"groupAgents",
                "tenant":"Resources",
                "metric":"CurrentReadyAgents",
                "notificationMode":"NoNotification"
            },
            "currEWT": {
                "objectId":"AssistanceCenter_live_VQs",
                "objectType":"groupQueues",
                "tenant":"Resources",
                "metric":"EstimatedWaitTimeGMS"
            },
            "AverHandleTime": {
                "objectId":"AssistanceCenter_live_VQs",
                "objectType":"groupQueues",
                "tenant":"Resources",
                "metric":"AverHandleTime",
                "timeProfile":"LastHour",
                "notificationMode":"NoNotification"
            }
        };
        
        const url = this.url + "?data=" + JSON.stringify(this.params);
        return this.request.get(url).then((resp) => {
            return JSON.parse(resp);
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/Stats/index.js